module.exports = __webpack_public_path__ + "img/style_0_3.527aa1f8.png";